import {
  HStack,
  Tag,
  TagLabel,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { BellIcon } from "@chakra-ui/icons";
import { keyframes } from "@emotion/react";
import { useEffect, useState } from "react";
import { useData } from "../../Contexts/DataContext";

const ring = keyframes`
  0% { transform: rotate(0); }
  2% { transform: rotate(-15deg); }
  4% { transform: rotate(10deg); }
  6% { transform: rotate(-10deg); }
  8% { transform: rotate(6deg); }
  10% { transform: rotate(-4deg); }
  12% { transform: rotate(2deg); }
  14% { transform: rotate(-1deg); }
  16% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;

const Notifications = () => {
  const { actions = [] } = useData();
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const [manuallyClosed, setManuallyClosed] = useState(false);

  const pendingDiscussions = actions.filter(
    (action) => action.type === "question"
  );

  const requirementIdsWithOpenQuestions = [
    ...new Set(pendingDiscussions.map((a) => a.requirementId)),
  ];

  const requirementCount = requirementIdsWithOpenQuestions.length;

  useEffect(() => {
    if (requirementCount > 0 && !manuallyClosed) {
      onOpen();
    }
  }, [requirementCount, manuallyClosed, onOpen]);

  const handleTagClick = () => {
    setManuallyClosed(false);
    onToggle();
  };

  const handleClose = () => {
    setManuallyClosed(true);
    onClose();
  };

  return (
    <HStack spacing={2}>
      {requirementCount > 0 && (
        <Popover
          isOpen={isOpen}
          onClose={handleClose}
          placement="bottom-start"
          closeOnBlur={false} // Prevent outside click from closing
        >
          <PopoverTrigger>
            <Tag
              m={2}
              p={1}
              colorScheme="red"
              fontSize="sm"
              borderRadius="3px"
              cursor="pointer"
              onClick={handleTagClick}
            >
              <BellIcon
                boxSize={5}
                mr={1}
                animation={`${ring} 5s infinite ease-in-out`}
                transformOrigin="center"
              />
              <TagLabel mr={1}>
                {pendingDiscussions.length} Pending Actions
              </TagLabel>
            </Tag>
          </PopoverTrigger>
          <PopoverContent w="auto">
            <PopoverArrow />
            <PopoverCloseButton color={"black"} />
            <PopoverBody fontSize="sm" color="black" pt={6}>
              You have {requirementCount} requirement
              {requirementCount > 1 ? "s" : ""} with open questions
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}
    </HStack>
  );
};

export default Notifications;
